import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  fill: "none",
  viewBox: "0 0 17 16",
  class: "th-icon"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, [...(_cache[0] || (_cache[0] = [
    _createElementVNode("path", {
      fill: "currentColor",
      d: "M8 11.333a.667.667 0 1 0 0 1.334h.007a.667.667 0 0 0 0-1.334z"
    }, null, -1),
    _createElementVNode("path", {
      fill: "currentColor",
      "fill-rule": "evenodd",
      d: "M4.667.667a2 2 0 0 0-2 2v10.666a2 2 0 0 0 2 2h6.666a2 2 0 0 0 2-2V2.667a2 2 0 0 0-2-2zm-.667 2C4 2.299 4.298 2 4.667 2h6.666c.368 0 .667.299.667.667v10.666a.667.667 0 0 1-.667.667H4.667A.667.667 0 0 1 4 13.333z",
      "clip-rule": "evenodd"
    }, null, -1)
  ]))]))
}
import { markRaw } from 'vue'
export default markRaw({ render: render })